module.exports = __webpack_public_path__ + "static/media/bg-banner-teen.fbb3483f.jpg";